/**
 * Mengubah timestamp ISO menjadi tanggal format Indonesia (23 Desember 2024)
 * @param {string} isoTimestamp - Timestamp dalam format ISO
 * @returns {string} - Tanggal dalam format "DD Bulan YYYY"
 */

const timeStampsToTanggalIndo = (isoTimestamp) => {
  const date = new Date(isoTimestamp); // Konversi ke objek Date
  const day = String(date.getDate()).padStart(2, "0"); // Ambil tanggal
  const monthNames = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ]; // Daftar nama bulan
  const month = monthNames[date.getMonth()]; // Ambil nama bulan
  const year = date.getFullYear(); // Ambil tahun
  return `${day} ${month} ${year}`; // Gabungkan menjadi format "DD Bulan YYYY"
};

export default timeStampsToTanggalIndo;
